export default "__VITE_ASSET__e0f80052__"